import script from "./KItemPosCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KItemPosCard.vue?vue&type=script&setup=true&lang=ts"

import "./KItemPosCard.vue?vue&type=style&index=0&id=5f6d20a2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6d20a2"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
